import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { openLanding, openTerminal } from '../lib/openLanding';
import { track } from '../lib/track';

/* Navigáció 1: ugyanazok a nevek mindenhol (Dashboard, Tanfolyamok, Kripto Terminál, Segédletek). A Dashboard,
   a Segédletek és a terminál a bejelentkezett munkamenettel nyílik (openLanding / openTerminal: a token a
   hash-ben megy, és a céloldal azonnal kitakarítja a címsorból). Mérés: egyetem_dashboard_kattintas {hely}. */
const toDashboard = (hely) => { track(null, 'egyetem_dashboard_kattintas', { hely }); openLanding('/dashboard'); };

const Navbar = ({ access }) => {
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setMenuOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Plusz: a landing --tier-plusz tokenje (kitöltött akcentus-cián, sötét betű)
  const isPlusz = access?.tier === 'plusz';
  const badge = access && (
    <span style={{
      fontSize: '11px', fontWeight: isPlusz ? 700 : 600,
      padding: '3px 10px', borderRadius: '100px', whiteSpace: 'nowrap',
      background: access.tier === 'pro'
        ? 'rgba(140,80,255,0.1)' : isPlusz ? '#00D2C8' : 'rgba(0,210,200,0.1)',
      border: access.tier === 'pro'
        ? '1px solid rgba(140,80,255,0.3)' : isPlusz ? '1px solid #00D2C8' : '1px solid rgba(0,210,200,0.3)',
      color: access.tier === 'pro' ? '#A97BFF' : isPlusz ? '#0a0f1e' : '#00D2C8',
    }}>
      {access.tier_label}
    </span>
  );

  const linkStyle = {
    color: 'rgba(255,255,255,0.5)', fontSize: '13px',
    textDecoration: 'none', whiteSpace: 'nowrap',
  };

  const dropdownItemStyle = {
    color: 'rgba(255,255,255,0.75)', fontSize: 14,
    textDecoration: 'none', display: 'block', textAlign: 'left',
    padding: '10px 14px', borderRadius: 8, width: '100%',
    background: 'none', border: 'none', cursor: 'pointer',
  };

  return (
    <nav style={{
      background: '#0a0a0f',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
      padding: isMobile ? '0 16px' : '0 24px', height: '60px',
      display: 'flex', alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky', top: 0, zIndex: 100,
    }}>
      <a href="https://web3kurzus.hu" style={{
        display: 'flex', alignItems: 'center', gap: '10px',
        textDecoration: 'none',
      }}>
        <img src="/logo2.png" alt="Web3 Kurzus" style={{ height: '32px', mixBlendMode: 'lighten' }} />
        <span style={{ color: 'white', fontWeight: 700, fontSize: '15px' }}>
          Web3 Kurzus
        </span>
        {!isMobile && (
          <span style={{
            fontSize: '11px', color: 'rgba(255,255,255,0.4)',
            background: 'rgba(255,255,255,0.06)',
            padding: '2px 8px', borderRadius: '4px',
          }}>
            Tanfolyamok
          </span>
        )}
      </a>

      {isMobile ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {badge}
          <button
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Menü"
            style={{
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.12)',
              color: 'rgba(255,255,255,0.8)',
              borderRadius: 8, padding: '6px 12px',
              fontSize: 16, cursor: 'pointer', lineHeight: 1,
            }}
          >
            ☰
          </button>
        </div>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {badge}
          <Link to="/tanfolyamok" style={linkStyle}>Tanfolyamok</Link>
          <a href="https://web3kurzus.hu/dashboard" style={linkStyle} onClick={(e) => { e.preventDefault(); toDashboard('fejlec'); }}>Dashboard</a>
          <a href="https://terminal.web3kurzus.hu" style={linkStyle} onClick={(e) => { e.preventDefault(); openTerminal('/'); }}>Kripto Terminál</a>
          <a href="https://web3kurzus.hu/segedletek" style={linkStyle} onClick={(e) => { e.preventDefault(); openLanding('/segedletek'); }}>Segédletek</a>
          <Link to="/bookmarks" style={linkStyle}>❤️ Mentett leckék</Link>
          <button
            onClick={() => supabase.auth.signOut()}
            style={{
              background: 'none', border: 'none',
              color: 'rgba(255,255,255,0.4)', cursor: 'pointer',
              fontSize: '13px',
            }}
          >
            Kilépés
          </button>
        </div>
      )}

      {/* Mobile dropdown */}
      {isMobile && menuOpen && (
        <>
          <div
            onClick={() => setMenuOpen(false)}
            style={{ position: 'fixed', inset: 0, zIndex: 150 }}
          />
          <div style={{
            position: 'absolute', top: '100%', right: 16, marginTop: 4,
            background: '#0a0a0f', border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 10, padding: 6, minWidth: 210, zIndex: 200,
            display: 'flex', flexDirection: 'column', gap: 2,
            boxShadow: '0 12px 32px rgba(0,0,0,0.5)',
          }}>
            <a href="https://web3kurzus.hu/dashboard" style={dropdownItemStyle} onClick={(e) => { e.preventDefault(); setMenuOpen(false); toDashboard('menu'); }}>
              📊 Dashboard
            </a>
            <Link to="/tanfolyamok" style={dropdownItemStyle} onClick={() => setMenuOpen(false)}>
              📚 Tanfolyamok
            </Link>
            <a href="https://terminal.web3kurzus.hu" style={dropdownItemStyle} onClick={(e) => { e.preventDefault(); setMenuOpen(false); openTerminal('/'); }}>
              📈 Kripto Terminál
            </a>
            <a href="https://web3kurzus.hu/segedletek" style={dropdownItemStyle} onClick={(e) => { e.preventDefault(); setMenuOpen(false); openLanding('/segedletek'); }}>
              📎 Segédletek
            </a>
            <Link to="/bookmarks" style={dropdownItemStyle} onClick={() => setMenuOpen(false)}>
              ❤️ Mentett leckék
            </Link>
            <button
              onClick={() => { setMenuOpen(false); supabase.auth.signOut(); }}
              style={{ ...dropdownItemStyle, color: '#f87171' }}
            >
              Kilépés
            </button>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
